import React from 'react';
import cn from 'classnames';
import { string, shape, arrayOf, func, bool } from 'prop-types';

import styles from './styles.module.scss';

const ToogleSwitch = ({ options, onChange, value, className, selectedTestId }) => {
  const switchIt = () => onChange(!value);
  return (
    <div className={`${styles.toogleContainer} ${className}`}>
      <div className={styles.slider}>
        <div className={styles.options}>
          {options.map(({ label, ...props }) => (
            <span {...props} key={label} onClick={switchIt}>
              {label}
            </span>
          ))}
        </div>
        <div
          className={cn(styles.positionTrack, { [styles.active]: value })}
          data-testid={!!value && selectedTestId}>
          {value ? options[1].label : options[0].label}
        </div>
      </div>
    </div>
  );
};

ToogleSwitch.propTypes = {
  className: string,
  options: arrayOf(
    shape({
      label: string
    })
  ),
  selectedTestId: string,
  value: bool,
  onChange: func
};

export default ToogleSwitch;
